/**
 * @flow
 * @format
 */

import { constants } from '../actions/errors';
import { constants as designConstants } from '../actions/design';

import type { StateType, ActionType, ErrorType } from '../actions/errors';

export const initialState: StateType = [];

function error(state: StateType = initialState, action: ActionType): StateType {
  switch (action.type) {
    case constants.API_ERROR: {
      const err: ErrorType = {
        type: action.type,
        data: {
          ...action.payload,
          timestamp: Date.now(),
        },
      };
      return state.concat(err);
    }

    case designConstants.STEP_RESET:
    case designConstants.NEW_DESIGN: {
      return initialState;
    }

    default:
      return state;
  }
}

export default error;



// WEBPACK FOOTER //
// ./src/reducers/errors.js